module.exports = __webpack_public_path__ + "media/packs/images/flags/TG-54e47ed20ba0f74ebc1f308b52b48ea1.png";